import { connect } from "react-redux"
import MasterSelect from "./MasterSelect"

const mapStateToProps = (state, props) => ({})

const mapDispatchToProps = (dispatch, props) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(MasterSelect)
